import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import PropTypes from 'prop-types';
import React from 'react';
import Switch from '@mui/material/Switch';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';

import MapPopper from './map-popper.jsx';
import {setOverlayOn} from '@explorer/actions/map.js';
import {trackEvent} from '@explorer/analytics';

export const OVERLAYS = {
  STILES: 'stiles',
  LABELS: 'labels',
  CENTER_MARKER: 'centerMarker',
};

const OVERLAY_LABELS = {
  user: 'overlaysMenu.user',
  [OVERLAYS.STILES]: 'overlaysMenu.stiles',
  [OVERLAYS.LABELS]: 'overlaysMenu.labels',
  [OVERLAYS.CENTER_MARKER]: 'overlaysMenu.centerMarker',
};

const LIST_WIDTH = 230;

const OverlayList = ({setOverlayOn, overlays, userOverlayUrl}) => {
  const {t} = useTranslation();
  const overlaysList = Object.values(OVERLAYS);
  if (userOverlayUrl) {
    overlaysList.push('user');
  }

  return (
    <List disablePadding sx={{width: LIST_WIDTH}}>
      {overlaysList.map(overlay => (
        <React.Fragment key={overlay}>
          <ListItem disablePadding>
            <ListItemText
              primary={
                OVERLAY_LABELS[overlay] ? t(OVERLAY_LABELS[overlay]) : overlay
              }
            />
            <ListItemSecondaryAction>
              <Switch
                color="primary"
                edge="end"
                onChange={() => {
                  trackEvent('Overlay toggled', {
                    name: overlay,
                    enabled: !overlays[overlay],
                  });
                  setOverlayOn({name: overlay, on: !overlays[overlay]});
                }}
                checked={overlays[overlay] === true}
              />
            </ListItemSecondaryAction>
          </ListItem>
        </React.Fragment>
      ))}
    </List>
  );
};

OverlayList.propTypes = {
  setOverlayOn: PropTypes.func,
  overlays: PropTypes.object,
  userOverlayUrl: PropTypes.string,
};

const LayerTools = ({
  open,
  anchorEl,
  setOverlayOn,
  overlays,
  userOverlayUrl,
}) => {
  const {t} = useTranslation();
  return (
    <MapPopper title={t('overlaysMenu.title')} open={open} anchorEl={anchorEl}>
      <OverlayList
        setOverlayOn={setOverlayOn}
        overlays={overlays}
        userOverlayUrl={userOverlayUrl}
      />
    </MapPopper>
  );
};

LayerTools.propTypes = {
  setOverlayOn: PropTypes.func,
  overlays: PropTypes.object,
  userOverlayUrl: PropTypes.string,
  open: PropTypes.bool,
  anchorEl: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.instanceOf(Element),
  ]),
};

const mapStateToProps = state => ({
  overlays: state.map.overlays,
  userOverlayUrl: state.map.userOverlayUrl,
});

const mapDispatchToProps = {
  setOverlayOn,
};

export default connect(mapStateToProps, mapDispatchToProps)(LayerTools);
